// Namespaced as `companyApproval` by the locale registrar (camelCase of the
// file name). The matching PHP lang file carries the server-side messages; the
// keys here are the ones the screen renders itself.
export default {
  title: 'تعميد الشركة',
  button: 'تعميد الشركة',
  copy_table: 'نسخ الجدول',
  copied: 'تم نسخ الجدول',
  copy_failed: 'تعذّر نسخ الجدول',
  copy_hint: 'يُنسخ الجدول بتنسيقه، فيُلصق في وورد أو الإيميل جدولاً كاملاً.',
  edit_hint: 'القيم محسوبة من المطالبة، ويمكن تعديل أي خانة أو اسم عمود قبل النسخ.',
  load_failed: 'تعذّر تحميل بيانات التعميد',

  // مراسلة الشركة
  mail_button: 'مراسلة الشركة',
  mail_title: 'مراسلة الشركة',
  mail_to: 'المستقبلون',
  mail_to_hint: 'إيميلات موظفي العميل. اكتب العنوان ثم اضغط Enter لإضافة عنوان آخر.',
  mail_subject: 'الموضوع',
  mail_body: 'المحتوى',
  mail_body_hint: 'المحتوى قابل للتعديل بالكامل قبل الإرسال.',
  mail_send: 'إرسال',
  mail_sent: 'تم إرسال الرسالة',
  mail_failed: 'تعذّر إرسال الرسالة',
  mail_needs_recipient: 'أضف مستقبلاً واحداً على الأقل',
  mail_needs_subject: 'اكتب موضوع الرسالة',
  mail_confirm: 'سيتم إرسال الرسالة فعلياً إلى {count} عنوان. متابعة؟',
  client: 'العميل',

  export_excel: 'تصدير Excel',
  exported: 'تم تنزيل الملف',

  mail_attachments: 'المرفقات',
  mail_add_attachments: 'إضافة ملفات',
  mail_attachments_hint: 'يمكن اختيار عدة ملفات دفعة واحدة، أو الضغط مرة أخرى لإضافة المزيد. حتى ١٠ ملفات، ١٠ ميجا للملف و١٥ ميجا للمجموع.',
  mail_too_many: 'الحد الأقصى {max} ملفات',
  mail_attachments_too_large: 'حجم المرفقات يتجاوز {max} ميجا',
  mail_tokens_hint: 'تُدرَج كما هي وتُملأ من المطالبة عند الإرسال. أو اضغط Ctrl ثلاث مرات داخل المحتوى.',

  add_column: 'عمود جديد',
  new_column: 'عمود جديد',
  columns_hint: 'يُضاف الحقل عموداً باسمه وقيمته. ويمكن ترتيب الأعمدة أو حذفها من الأزرار فوق كل عمود.',
  save_settings: 'حفظ الإعدادات',
  load_settings: 'استرجاع المحفوظ',
  settings_saved: 'تم حفظ الإعدادات',
  settings_loaded: 'تم استرجاع الإعدادات المحفوظة',
  settings_save_failed: 'تعذّر حفظ الإعدادات',
  reset_settings: 'إعادة الضبط',
  reset_confirm: 'ستُلغى كل التعديلات ويعود الشكل الافتراضي. متابعة؟',
  settings_reset: 'أُعيد الشكل الافتراضي',

  move_start: 'تحريك يميناً',
  move_end: 'تحريك يساراً',
  remove_column: 'حذف العمود',

  palette_title: 'الحقول',
  palette_search: 'ابحث عن حقل…',
  palette_empty: 'لا يوجد حقل مطابق',
  palette_hint: '↑ ↓ للتنقل · Enter للإدراج · Esc للإغلاق',

  // The columns, in the order they are printed (right to left).
  columns: {
    pay_type: 'نوع السداد',
    remaining: 'المتبقي للسداد',
    discount_percent: 'نسبة الخصم',
    previous_paid: 'سداد سابق',
    paid: 'المبلغ المسدد',
    amount_after_discount: 'المبلغ المطالبة بعد الخصم',
    base_amount: 'المبلغ الأساسي',
    pay_date: 'تاريخ السداد',
    assign_date: 'تاريخ الإسناد',
    claim_number: 'رقم المطالبة',
    transferor: 'اسم المحول'
  }
};
